import SelectAbstract from "components/SelectAbstract";
import PropTypes from 'prop-types';

import Input from "components/Input";
import Calendar from "components/Calendar";
import Button from "components/Button";

import { ReactComponent as CalendarIcon } from 'icons/components/calendar.svg';

import './themes/default.less';
import './index.less';

export default class SelectDateRange extends SelectAbstract {

    constructor(props) {
        super(props);

        this.periods = [1, 2, 3, 4, 5, 6, 12].map(id => {
            const name = ((id === 1 || id === 12) ? "1 " : "") + this._helper.date.diffFrom(null, this._helper.date.addMonth(null, id));
            return { id, name };
        });

        const initialDate = props.defaultValue ? this._helper.date.create(props.defaultValue) : new Date();

        this.state = {
            value1: initialDate,
            value2: props.mode === "past" ? null : this._helper.date.addDays(initialDate, 7),
            selected: initialDate,
            index: -1,
            selectedRange: {
                type: props.mode === "past" ? 0 : 1,
                selectedStartDate: new Date(),
                selectedEndDate: props.mode === "past" ? null : this._helper.date.addDays(null, 7),
                interval: props.mode === "past" ? 1 : 8,
                customRange: 0,
            },
        };

        /*
        this.state = {
            value1: new Date(),
            value2: this._helper.date.addMonth(new Date(), 1),
            selected: new Date(),
            selectedRange: {
                type: 0,
                selectedStartDate: new Date(),
                selectedEndDate: null,
                interval: 1,
                customRange: 0,
            },
        };*/
    }

    static propTypes = {
        ...SelectAbstract.propTypes,
        futureOff: PropTypes.bool,
        mode: PropTypes.string,
        showAddCal: PropTypes.bool,
    };

    static defaultProps = {
        ...SelectAbstract.defaultProps,
        futureOff: true,
        mode: "past",
        showAddCal: false
    };

    set value(date) {
        const newDate = this._helper.date.create(date);
        this.setState({
            value1: newDate,
            selected: newDate,
        });
        this.inputDate.value = this._helper.date.toStr(newDate, 'DD.MM.YYYY');
    }

    get value() {
        return this.state.value1;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            const newDate = this._helper.date.create(this.props.defaultValue);
            this.setState({
                value1: newDate,
                selected: newDate,
            });
            this.inputDate.value = this._helper.date.toStr(newDate, 'DD.MM.YYYY');
        }
    }

    getMainStyle() {
        return "selectDateRange";
    }

    setInputValue(selectedRange) {
        if (selectedRange.type === 0)
            this.inputDate.value = this._helper.date.toStr(selectedRange.selectedStartDate, 'DD.MM.YYYY');
        else {
            const sdate = this._helper.date.toStr(selectedRange.selectedStartDate, 'DD.MM.YYYY');
            const edate = this._helper.date.toStr(selectedRange.selectedEndDate, 'DD.MM.YYYY');
            this.inputDate.value = `${sdate}-${edate}`;
        }
    }

    onChange(date) {
        const { selectedRange } = this.state;
        const { mode } = this.props;
        let { selectedEndDate, selectedStartDate, type, interval } = selectedRange;

        let selectedRangeNew = {};
        if ((type === 3 && mode === "past") || type === 4) {
            if (selectedRange.customRange === 1) {
                const diff = this._helper.date.daysDiff(selectedStartDate, date);

                selectedRangeNew = {
                    ...selectedRange,
                    selectedEndDate: date,
                    customRange: 2,
                    interval: diff + 1
                };
            } else {
                selectedRangeNew = {
                    ...selectedRange,
                    selectedEndDate: this._helper.date.addMonth(date, 1),
                    selectedStartDate: date,
                    customRange: 1,
                    interval: 1
                };
            }
        } else {
            if (type === 1 || type === 2)
                selectedEndDate = this._helper.date.addDays(date, interval - 1);
            else if (type === 3)
                selectedEndDate = this._helper.date.addMonth(date, 1);

            selectedRangeNew = { ...selectedRange, selectedStartDate: date, selectedEndDate };
        }

        this.setInputValue(selectedRangeNew);
        this.changeState("selectedRange", selectedRangeNew);
    }

    onCalendarFirstMonthChange(date) {
        this.changeState('value2', this._helper.date.addMonth(date, 1));
        this.changeState('value1', date);
    }
    onCalendarSecondMonthChange(date) {
        this.changeState('value1', this._helper.date.addMonth(date, -1));
        this.changeState('value2', date);
    }

    renderSelector() {
        return (
            <div
                ref={el => this.selector = el}
                className={"selectorDate flex centerV hand" + this.props.selectorStyle ? this.props.selectorStyle : ""}
                onClick={this.toggleOpenedState.bind(this)}>
                <Input
                    ref={el => this.inputDate = el}
                    placeHolder="client.date"
                    inputStyle={this.props.inputStyle ? this.props.inputStyle : "text p1"}
                    readonly={true}
                    label="client.period"
                    iconRight={<CalendarIcon />}
                />
            </div>
        );
    }

    onChangeRange(type) {
        const dt = new Date();

        let selectedStartDate = dt;
        let selectedEndDate = null;
        let interval = 1;
        const customRange = 0;

        if (type !== 0)
            selectedEndDate = dt;

        if (type === 1) {
            selectedStartDate = this._helper.date.addDays(dt, -7);
            interval = 8;
            this.changeState("value2", selectedEndDate);
        } else if (type === 2) {
            selectedStartDate = this._helper.date.addMonth(dt, -1);
            const diff = this._helper.date.daysDiff(selectedStartDate, selectedEndDate);
            interval = diff + 1;
            this.changeState("value2", selectedEndDate);
        } else if (type === 3) {
            interval = 1;
            this.changeState("value2", this._helper.date.addMonth(selectedStartDate, 1));
        }

        const selectedRangeNew = { type, selectedStartDate, selectedEndDate, interval, customRange };
        this.setInputValue(selectedRangeNew);
        this.setState({ selectedRange: selectedRangeNew, value1: selectedStartDate });
    }


    onChangeRange2(type) {
        const dt = new Date();

        let selectedStartDate = dt;
        let selectedEndDate = this._helper.date.addDays(dt, 7);
        let interval = 8;
        let value2 = selectedEndDate;
        const customRange = 0;

        if (type === 2) {
            selectedEndDate = this._helper.date.addDays(dt, 14);
            interval = 15;
            value2 = selectedEndDate;
        } else if (type === 3) {
            selectedEndDate = this._helper.date.addMonth(dt, 1);
            const diff = this._helper.date.daysDiff(selectedStartDate, selectedEndDate);
            interval = diff + 1;
            value2 = selectedEndDate;
        } else if (type === 4) {
            interval = 1;
            value2 = this._helper.date.addMonth(dt, 1);
        }

        const selectedRangeNew = { type, selectedStartDate, selectedEndDate, interval, customRange };
        this.setInputValue(selectedRangeNew);
        this.setState({ selectedRange: selectedRangeNew, value1: dt, value2 });

    }
    renderRangeType(text, id, onClick) {
        const { selectedRange } = this.state;
        return (
            <div
                className={`rangeType text p1 hand ${selectedRange.type === id ? "active" : ""}`}
                onClick={onClick}>
                {this.tr(text)}
            </div>
        );
    }

    onHide() {
        this.setOpenedState(false);
    }

    onForm() {
        const { selectedRange } = this.state;
        if (this.props.onForm.apply)
            this.props.onForm(selectedRange);
        this.setOpenedState(false);
    }

    checkShowSecondCalendar() {
        const { type, selectedStartDate, selectedEndDate } = this.state.selectedRange;

        if (type === 3) {
            return true;
        } else if (type !== 0 && selectedStartDate.getMonth() !== selectedEndDate.getMonth()) {
            return true;
        }

        return false;
    }

    renderRangeTypesPast() {
        return (<div className="rangeTypeBlock flex col gap16">
            {this.renderRangeType("report.forOneDay", 0, this.onChangeRange.bind(this, 0))}
            {this.renderRangeType("report.forLastWeek", 1, this.onChangeRange.bind(this, 1))}
            {this.renderRangeType("report.forLastMonth", 2, this.onChangeRange.bind(this, 2))}
            {this.renderRangeType("report.setManually", 3, this.onChangeRange.bind(this, 3))}
        </div>);
    }

    renderRangeTypesFuture() {
        return (<div className="rangeTypeBlock flex col gap16">
            {this.renderRangeType("На неделю", 1, this.onChangeRange2.bind(this, 1))}
            {this.renderRangeType("На две недели", 2, this.onChangeRange2.bind(this, 2))}
            {this.renderRangeType("На месяц", 3, this.onChangeRange2.bind(this, 3))}
            {this.renderRangeType("report.setManually", 4, this.onChangeRange2.bind(this, 4))}
        </div>);
    }

    renderPopup() {
        const { value1, value2, selectedRange } = this.state;
        const { futureOff, mode, showAddCal } = this.props;

        return (
            <div ref={el => this.popup = el} className="selectPopup pos abs ">
                <div className="flex col gap16">
                    <div className="flex centerH gap16">
                        <div className="calendarCont">
                            <Calendar
                                value={value1}
                                selected={selectedRange ? selectedRange.selectedStartDate : null}
                                interval={selectedRange ? selectedRange.interval : null}
                                onChange={this.onChange.bind(this)}
                                futureOff={futureOff}
                                onMonthChange={this.onCalendarFirstMonthChange.bind(this)}
                            />
                        </div>
                        {(this.checkShowSecondCalendar() || showAddCal) && <div className="calendarCont">
                            <Calendar
                                value={value1?.getMonth() === value2?.getMonth() ? this._helper.date.addMonth(value2, 1) : value2}
                                selected={selectedRange ? selectedRange.selectedStartDate : null}
                                interval={selectedRange ? selectedRange.interval : null}
                                onChange={this.onChange.bind(this)}
                                futureOff={futureOff}
                                onMonthChange={this.onCalendarSecondMonthChange.bind(this)}
                            />
                        </div>}
                        {mode === "past" ? this.renderRangeTypesPast() : this.renderRangeTypesFuture()}
                    </div>
                    <div className="buttons flex end">
                        <div className="flex gap16">
                            <Button
                                label="main.cancel"
                                size="small"
                                type="transparent"
                                onClick={this.onHide.bind(this)}
                            />
                            <Button
                                label="report.form"
                                size="small"
                                onClick={this.onForm.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
